import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=1cf8ffcd"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf8ffcd')) {
      api.createRecord('1cf8ffcd', component.options)
    } else {
      api.reload('1cf8ffcd', component.options)
    }
    module.hot.accept("./Pages.vue?vue&type=template&id=1cf8ffcd", function () {
      api.rerender('1cf8ffcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Pages.vue"
export default component.exports